import * as React from 'react';
import { THEME } from 'src/styles/theme';
import Box from '@mui/material/Box';
import CircularProgress, {
  circularProgressClasses,
  CircularProgressProps,
} from '@mui/material/CircularProgress';
import { BsFillCheckCircleFill } from 'react-icons/bs';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  svg {
    color: ${props => props.theme.main.primary};
    font-size: 1.65em;
    margin-left: 6px;
    margin-right: 2px;
  }
`;

function CustomCircularProgress(props: CircularProgressProps) {
  if (props.value === 100)
    return (
      <Wrapper>
        <BsFillCheckCircleFill />
      </Wrapper>
    );
  return (
    <Box sx={{ position: 'relative' }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: THEME.main.grey,
        }}
        size={25}
        thickness={8}
        {...props}
        value={100}
      />
      <CircularProgress
        disableShrink
        variant="determinate"
        sx={{
          color: THEME.main.primary,
          animationDuration: '550ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        }}
        size={25}
        thickness={8}
        {...props}
      />
    </Box>
  );
}

export default CustomCircularProgress;
